import { produce } from 'immer';
import { Draft, DraftState } from '@/types';
import { DraftDispatch } from '@/redux/draft/draftDispatch';
import { cleanupDraft } from '@/components/draft/draftState/actions/cleanupDraft';
import { removeConfigurationAction } from '@/components/draft/draftState/actions/removeConfigurationAction';

export const getCleanDraft = <DraftType extends Draft>(
  draft: DraftType,
  dispatch: DraftDispatch
) => {
  const cleanedDraft = produce(draft, (writableDraft: Draft | DraftState) =>
    cleanupDraft(writableDraft)
  );
  const configurationsInCleanedDraft = new Set(cleanedDraft.configurationIds);
  const removedConfigurations = draft.configurationIds
    .filter((configurationId) => !configurationsInCleanedDraft.has(configurationId))
    .map((removedConfigurationId) => draft.configurations[removedConfigurationId]);

  if (removedConfigurations.length > 0) {
    dispatch(removeConfigurationAction(removedConfigurations));
  }

  return cleanedDraft;
};
